import { render, staticRenderFns } from "./SolidPieForResult.vue?vue&type=template&id=6c290159&scoped=true&"
import script from "./SolidPieForResult.vue?vue&type=script&lang=js&"
export * from "./SolidPieForResult.vue?vue&type=script&lang=js&"
import style0 from "./SolidPieForResult.vue?vue&type=style&index=0&id=6c290159&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c290159",
  null
  
)

export default component.exports